import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconShareAlt';
/** Renders an SVG icon. */
const SvgShareAlt = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M6 25V13a3 3 0 0 1 3-3h2a1 1 0 1 1 0 2H9a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1h-2a1 1 0 1 1 0-2h2a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3m9-7V4.703l-2.342 2.05a1 1 0 0 1-1.316-1.506l4-3.5.072-.057a1 1 0 0 1 1.244.057l4 3.5a1 1 0 0 1-1.236 1.57l-.08-.064L17 4.703V18a1 1 0 1 1-2 0"
      />
    </svg>
  );
};
SvgShareAlt.displayName = displayName;
export default SvgShareAlt;
